export const getNavigatorLanguage = (lang: string) => {
  if (lang.includes('-')) {
    return lang.split('-')[0];
  } else {
    return lang;
  }
};
